import React from 'react'
import { Box, Typography } from '@mui/material'
import img from '../../../assets/images/articles/A1.jpeg'
import { Link } from 'react-router-dom'
import news_img from '../../../assets/images/common/news_img.jpg'

function NewsCard({ image_url, title, link, pubDate,  }) {

  const newsImage = image_url ? image_url : news_img;

  return (
    <Box sx={{ width: '100%', height: { xs: '11vh', md: '13vh' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
      <Box sx={{ width: '25%', height: '100%', bgcolor: '#242424', display: 'flex', justifyContent: 'right' }} >
        <Box component="img" src={newsImage} sx={{ width: '95%', height: '95%' }} />
      </Box>
      <Box sx={{ width: '70%', px: 1, height: '100%' }} >
        <Box sx={{ height: '20%', }} >
          <Typography sx={{ fontSize: '0.7rem', fontWeight: '600', color: 'grey' }} >{pubDate}</Typography>
        </Box>
        <Box sx={{ height: '73%', pt: 1 }} >
          <Typography sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' }, fontWeight: '600' }} ><Link to={link} target='_blank' style={{ textDecoration: 'none', color: '#242424' }} >{title}</Link></Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default NewsCard
